/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/159-trophy': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13 3V1H3v2H0v2a3 3 0 003.9 2.862A5 5 0 007 9.899v3.1H6a2 2 0 00-2 2h8a2 2 0 00-2-2H9v-3.1a5.003 5.003 0 003.1-2.037A3 3 0 0016 5V3h-3zM3 6.813A1.815 1.815 0 011.187 5V4H3v1c0 .628.116 1.229.327 1.782-.106.019-.216.03-.327.03zM14.813 5a1.815 1.815 0 01-2.14 1.783A4.994 4.994 0 0013 5.001v-1h1.813v1z"/>'
  }
})
